import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from "flarum/common/Model";
/**
 * A report filed against a chat message.
 *
 * The chat keeps its own rather than reusing flarum/flags: that extension's
 * `flags.post_id` is a non-nullable foreign key into `posts`, so a chat message id
 * cannot be stored there at all.
 */
export default class MessageFlag extends Model {
  constructor() {
    super(...arguments);
    /** One of the keys MessageFlag::REASONS lists on the server. */
    _defineProperty(this, "reason", Model.attribute("reason"));
    /** The reporter's own words. Always rendered as text, never as HTML. */
    _defineProperty(this, "detail", Model.attribute("detail"));
    _defineProperty(this, "messageId", Model.attribute("messageId"));
    _defineProperty(this, "createdAt", Model.attribute("createdAt", Model.transformDate));
    _defineProperty(this, "resolvedAt", Model.attribute("resolvedAt", Model.transformDate));
    _defineProperty(this, "isResolved", Model.attribute("isResolved"));
    /** Null once the reporter deletes their account — the report outlives them. */
    _defineProperty(this, "user", Model.hasOne("user"));
    _defineProperty(this, "message", Model.hasOne("message"));
    _defineProperty(this, "resolvedBy", Model.hasOne("resolvedBy"));
  }
  apiEndpoint() {
    return "/chat-message-flags" + (this.exists ? "/" + this.id() : "");
  }
}
flarum.reg.add('ramon-chat', 'common/models/MessageFlag', MessageFlag);